import { useAction, useAtom } from '@reatom/npm-react'
import { useState } from 'react'
import { useEffectOnce } from 'react-use'
import styled from 'styled-components'

import { AsyncStateN } from '@blade/std-lib'
import { CommentMessage } from '@root/entities/comment/ui'
import { Network, selectedNetworkAtom } from '@root/entities/network'

import type { Comment } from '@root/entities/comment'
import type { CommentsModel } from '@root/features/comment/atoms'

type CommentItemBodyReplyProps = {
  comment: Comment.Comment
  model: CommentsModel
}

export const CommentItemBodyReply = ({
  comment,
  model,
}: CommentItemBodyReplyProps) => {
  const [content, setContent] = useState<string>('')
  const [image, setImage] = useState<string | undefined>(undefined)

  const [network] = useAtom(selectedNetworkAtom)
  const [_, setReplyCommentId] = useAtom(model.replyCommentIdAtom)
  const createComment = useAction(model.createCommentAction)
  const [createCommentRequestState] = useAtom(model.createCommentRequestState)

  useEffectOnce(() => {
    model.commentCreatedEvent.onCall((_, __, [createdComment]) => {
      const isOwner = createdComment.parentCommentId === comment.id

      // skip if not an owner
      if (!isOwner) {
        return
      }

      setReplyCommentId(undefined)
      setContent('')
    })
  })

  const handleClose = () => setReplyCommentId(undefined)
  const handleMessageSend = () =>
    createComment({
      pairAddress: comment.pairAddress,
      req: {
        network: Network.toDto(network),
        content,
        parentCommentId: comment.id,
        imageAttachment: image,
      },
    })

  return (
    <Root
      isLoading={AsyncStateN.isLoading(createCommentRequestState)}
      disabled={AsyncStateN.isLoading(createCommentRequestState)}
      text={content}
      onChange={(value) => setContent(value)}
      onMessageSend={handleMessageSend}
      onClose={handleClose}
      imageAttached={image}
      onImageAttachedChange={setImage}
    />
  )
}

const Root = styled(CommentMessage)`
  width: 100%;
  margin-bottom: 20px;
`
